import type { ReactNode } from "react";
import { EmptyState } from "@dfws/ui";
import s from "./Placeholder.module.css";

export function Placeholder({ icon, title, children }: { icon: ReactNode; title: string; children: ReactNode }) {
  return (
    <div className={s.surface}>
      <EmptyState icon={icon} title={title}>
        {children}
      </EmptyState>
    </div>
  );
}
